import createSvgIcon from "./utils/create_icon"

const PaperPlaneOutline = createSvgIcon(<path clipRule="evenodd" d="M4.447 3.106A1 1 0 0 0 3.03 4.243L4.97 12l-1.94 7.758a1 1 0 0 0 1.417 1.136l16-8a1 1 0 0 0 0-1.788zM6.781 11 5.497 5.867 17.764 12 5.497 18.133 6.781 13H11a1 1 0 1 0 0-2z" fill="currentColor" fillRule="evenodd" />, "PaperPlaneOutline")
export default PaperPlaneOutline
